import { useTranslation } from '@multaqa/i18n'
import { EditIcon, RotateCcwIcon } from 'lucide-react'
import { type RecordHeaderAction, RecordHeaderActions } from '@/components/record-header-actions'

export function SupplierHeaderActions({
  supplierId,
  canEdit,
  canDelete,
  isActive,
  activatePending,
  onDeactivate,
  onActivate,
}: {
  supplierId: string
  canEdit: boolean
  canDelete: boolean
  isActive: boolean
  activatePending: boolean
  onDeactivate: () => void
  onActivate: () => void
}) {
  const { t } = useTranslation()
  const actions: RecordHeaderAction[] = [
    {
      id: 'edit',
      label: t('action.edit'),
      icon: EditIcon,
      primary: true,
      hidden: !canEdit,
      link: { to: '/suppliers/$supplierId/edit', params: { supplierId } },
    },
    isActive
      ? {
          id: 'deactivate',
          label: t('supplier.deactivate'),
          variant: 'destructive',
          hidden: !canDelete,
          onSelect: onDeactivate,
        }
      : {
          id: 'activate',
          label: t('supplier.activate'),
          icon: RotateCcwIcon,
          disabled: activatePending,
          loading: activatePending,
          onSelect: onActivate,
        },
  ]

  return <RecordHeaderActions actions={actions} menuTestId="supplier-more-actions" />
}
